<ng-container *transloco="let convert;">
  <app-modal [modalId]="modalId">
    <header class="modal__header">
      <h1
        class="modal__title"
        [attr.id]="modalId + '-title'"
        tabindex="-1"
        >
        {{convert('reports.emailModal.headerSendMail')}}
      </h1>
    </header>
    <div class="modal__content form-group">
      <label class="d-block text-start" id="email-label" for="email">{{convert('reports.emailModal.labelEmailAddress')}}</label>
      <input
        class="form-control modal__form-control"
        type="text"
        id="email"
        required
        aria-required="true"
        [(ngModel)]="email"
        />
      @if (errorMessage) {
        <div class="mt-2">
          @if (errorMessage) {
            <p class="mb-0 text-danger text-start fw-bold">{{errorMessage}}</p>
          }
        </div>
      }
      <p class="modal__content--info text-start">
        {{convert('reports.emailModal.modaltext')}}
      </p>
    </div>
    <div class="modal__action">
      <button
        class="btn btn-primary bid-buttons action-btns"
        (click)="sendEmail()"
        [disabled]="isSubmitting"
        data-track-elem="button"
        data-track-name="Save"
        id="do_save_button"
        allytmln="Send Email"
        >
        {{convert('reports.emailModal.btnSend')}}
      </button>
      <button
        class="btn btn-secondary cancel-btn bid-buttons action-btns"
        (click)="cancel()"
        data-track-elem="button"
        data-track-name="Cancel"
        data-track-trigger="close"
        id="do_cancel_button"
        allytmln="Cancel Email"
        >
        {{convert('common.btnCancel')}}
      </button>
    </div>

    <div class="modal-close-container">
      <button
        class="modal__close"
        [attr.aria-label]="convert('common.modalClose')"
        (click)="cancel()"
        data-track-elem="icon"
        data-track-name="Close"
        data-track-trigger="close"
        id="do_close_x_button"
        >
        <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
      </button>
    </div>
  </app-modal>

  <app-action-submitted-content-modal
    heading="{{convert('reports.emailModal.textEmailSent')}}"
    [content]="submittedModalContent"
    >
  </app-action-submitted-content-modal>
</ng-container>
